/**
 * Extract user ID from various possible auth user shapes.
 */
export const getUserIdFromUser = (user) => {
  return (
    user?.userId ||
    user?.id ||
    user?._id ||
    user?.userInfo?.userId ||
    user?.userInfo?.id ||
    user?.userInfo?._id ||
    null
  );
};

/**
 * Get the user's profile image from various possible shapes.
 */
export const getUserImage = (user) => {
  return (
    user?.imageUrl ||
    user?.image ||
    user?.image_url ||
    user?.profile_image ||
    user?.profileImage ||
    null
  );
};

/**
 * Normalize a WebSocket message to ensure proper sender.agent property
 * and consistent message structure.
 */
export const normalizeWebSocketMessage = (wsMessage, { currentUserId, currentUserImage }) => {
  // If already has sender.agent property set, return as is
  if (wsMessage?.sender?.agent !== undefined) {
    return wsMessage;
  }

  let isAgent = false;

  if (wsMessage.senderType === "AGENT" || wsMessage.senderType === "agent") {
    isAgent = true;
  } else if (wsMessage.senderType === "BOT" || wsMessage.senderType === "bot") {
    isAgent = true;
  } else if (wsMessage.senderType === "USER" || wsMessage.senderType === "user") {
    isAgent = false;
  } else {
    if (wsMessage.sender?.isEmployee === true) {
      isAgent = true;
    } else if (wsMessage.sender?.roles && Array.isArray(wsMessage.sender.roles)) {
      const hasOrgRole = wsMessage.sender.roles.some(
        (role) =>
          role.includes("ORGANIZATION") ||
          role.includes("EMPLOYEE") ||
          role.includes("MANAGER") ||
          role.includes("ADMIN") ||
          role.includes("AGENT"),
      );
      if (hasOrgRole) isAgent = true;
    } else if (wsMessage.senderId && typeof wsMessage.senderId === "number" && wsMessage.senderId <= 100) {
      isAgent = true;
    } else if (!wsMessage.sender && !wsMessage.senderId) {
      isAgent = true;
    }
  }

  const isCurrentUser =
    wsMessage.senderId === currentUserId ||
    wsMessage.sender?._id === currentUserId ||
    wsMessage.sender?.id === currentUserId;

  const normalized = {
    ...wsMessage,
    sender: wsMessage.sender
      ? {
          ...wsMessage.sender,
          agent: isAgent,
          _id: wsMessage.sender._id || wsMessage.sender.id || wsMessage.senderId,
          name: wsMessage.sender.name || wsMessage.senderName || (isAgent ? "Agent" : "Customer"),
          image: wsMessage.sender.image || wsMessage.senderImage || wsMessage.sender.imageUrl || (isCurrentUser ? currentUserImage : null) || null,
          roles: wsMessage.sender.roles || [],
          isEmployee: wsMessage.sender.isEmployee || isAgent,
        }
      : {
          _id: wsMessage.senderId || null,
          name: wsMessage.senderName || (isAgent ? "Bot" : "Customer"),
          image: wsMessage.senderImage || (isCurrentUser ? currentUserImage : null) || null,
          agent: isAgent,
          roles: [],
          isEmployee: isAgent,
        },
    _id: wsMessage._id || wsMessage.messageId || `ws_${Date.now()}`,
    messageId: wsMessage.messageId || wsMessage._id,
    chatId: wsMessage.chatId || wsMessage.chat?.id,
    content: wsMessage.content || "",
    createdAt: wsMessage.createdAt || new Date().toISOString(),
  };

  return normalized;
};
